<form [formGroup]="form" [ngClass]="{'invalid-submit': invalidSubmit}">
  <!-- Campaign -->
  <div class="ui-g-12">
    <div class="ui-g-12 ui-md-4">
      <label class="required">{{ 'campaign.campaign' | translate }}</label>
    </div>
    <div class="ui-g-12 ui-md-6">
      <p-autoComplete [style]="{'width':'90%'}" [inputStyle]="{'width':'80%'}" [suggestions]="campaignList" formControlName="campaign" (completeMethod)="filterCampaign($event)"
        (onSelect)="onCampaignSelection($event)" [minLength]="2" [dropdown]="true" field="name">
      </p-autoComplete>
    </div>
  </div>
  <!-- Campaign Action -->
  <div class="ui-g-12">
    <div class="ui-g-12 ui-md-4">
      <label class="required">{{ 'campaign.campaignAction' | translate }}</label>
    </div>
    <div class="ui-g-12 ui-md-6">
      <p-autoComplete [style]="{'width':'90%'}" [inputStyle]="{'width':'80%'}" [suggestions]="campaignActionList" formControlName="campaignAction"
        [disabled]="!form.get('campaign').value" (completeMethod)="filterCampaignAction($event)"
        (onSelect)="onCampaignActionSelection($event)" [minLength]="2" [dropdown]="true" field="name">
      </p-autoComplete>
    </div>
  </div>
  <!-- Date Emissione -->
  <div class="ui-g-12">
    <div class="ui-g-12 ui-md-4">
      <label class="required">{{ 'campaign.emissionStartDate' | translate }}</label>
    </div>
    <div class="ui-g-12 ui-md-6">
      <app-kv-calendar #emissionStartField data-testid="emissionStartField" [inputName]="'emissionStartDate'" [formData]="form"
        [startDateSelector]="true" [endDateInputName]="'emissionEndDate'" [endDateCalendar]="emissionEndField"
        [minDate]="startCampaignDate" [maxDate]="endCampaignDate" [disabled]="!startCampaignDate || !endCampaignDate" style="width: 90%;">
      </app-kv-calendar>
    </div>
  </div>
  <div class="ui-g-12">
    <div class="ui-g-12 ui-md-4">
      <label class="required">{{ 'campaign.emissionEndDate' | translate }}</label>
    </div>
    <div class="ui-g-12 ui-md-6">
      <app-kv-calendar #emissionEndField data-testid="emissionEndField" [inputName]="'emissionEndDate'" [formData]="form" [endDateSelector]="true"
        [startDateInputName]="'emissionStartDate'" [startDateCalendar]="emissionStartField"
        [minDate]="startCampaignDate" [maxDate]="endCampaignDate" [disabled]="!startCampaignDate || !endCampaignDate">
      </app-kv-calendar>
    </div>
  </div>
  <!-- Date Fruizione -->
  <div class="ui-g-12" *ngIf="actionTypeCode !== 'MSG'">
    <div class="ui-g-12 ui-md-4">
      <label class="required">{{ 'campaign.fruitionStartDate' | translate }}</label>
    </div>
    <div class="ui-g-12 ui-md-6">
      <app-kv-calendar #fruitionStartField data-testid="fruitionStartField" [inputName]="'fruitionStartDate'" [formData]="form"
        [startDateSelector]="true" [endDateInputName]="'fruitionEndDate'" [endDateCalendar]="fruitionEndField"
        [minDate]="form.get('emissionStartDate').value" [maxDate]="endCampaignDate"
        [disabled]="!form.get('emissionStartDate').value">
      </app-kv-calendar>
    </div>
  </div>
  <div class="ui-g-12" *ngIf="actionTypeCode !== 'MSG'">
    <div class="ui-g-12 ui-md-4">
      <label class="required">{{ 'campaign.fruitionEndDate' | translate }}</label>
    </div>
    <div class="ui-g-12 ui-md-6">
      <app-kv-calendar #fruitionEndField data-testid="fruitionEndField" [inputName]="'fruitionEndDate'" [formData]="form" [endDateSelector]="true"
        [startDateInputName]="'fruitionStartDate'" [startDateCalendar]="fruitionStartField"
        [minDate]="form.get('emissionEndDate').value" [maxDate]="endCampaignDate"
        [disabled]="!form.get('emissionEndDate').value">
      </app-kv-calendar>
    </div>
  </div>
  <!-- Item Code -->
  <div class="ui-g-12">
    <div class="ui-g-12 ui-md-4">
      <label class="required">{{ 'campaign.itemCode' | translate }}</label>
    </div>
    <div class="ui-g-12 ui-md-6">
      <p-autoComplete [style]="{'width':'90%'}" [inputStyle]="{'width':'80%'}" class="auto-complete" formControlName="itemCode" [suggestions]="productItemList"
        (completeMethod)="filterByProductItem($event)" (onSelect)="getProductItemBarcode($event)" [minLength]="2"
        [dropdown]="true" [delay]="500" field="label">
      </p-autoComplete>
      <span class="input-error-notification" *ngIf="invalidSubmit && form.controls['itemCode'].errors?.required">{{ 'campaign.itemCodeValidator' |
        translate }}</span>
    </div>
  </div>
  <div class="ui-g-12">
    <div class="ui-g-12 ui-md-4">
      <label class="required">{{ 'promotion.barCode' | translate }}</label>
    </div>
    <div class="ui-g-12 ui-md-6">
      <p-dropdown formControlName="barCode"
        [disabled]="!form.get('itemCode').value" [options]="productItemBarcodeList" [style]="{'width':'84%'}">
      </p-dropdown>
      <span class="input-error-notification" *ngIf="invalidSubmit && form.controls['barCode'].errors?.required">{{ 'campaign.barcodeValidator' |
        translate }}</span>
    </div>
  </div>
  <!-- nome nuovo per l'azione da duplicare -->
  <div class="ui-g-12">
    <div class="ui-g-12 ui-md-4">
      <label class="required">{{ 'campaign.duplicateActionName' | translate }}</label>
    </div>
    <div class="ui-g-12 ui-md-6">
      <input type="text" pInputText formControlName="duplicateActionName" style="width: 84%;">
    </div>
  </div>
  <div class="ui-g-12 text-center">
    <button pButton (click)="duplicateCampaignAction()" type="button" class="k-generic-btn"
      label="{{ 'common.duplicate' | translate }}">
    </button>
  </div>
</form>



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/campaign-list2/campaign-action-duplicate-form/campaign-action-duplicate-form.component.html